import { NotesPanel } from "@/components/shared/NotesPanel";
import { MentionTextarea } from "@/components/form/MentionTextarea";
import { useAuth } from "@/context/AuthContext";

// Multi-note panel for saved records; a single starter note box while creating.
export function ModalNotes({ entityType, collection, record, value, onChange, testid }) {
  const { users } = useAuth();
  if (!record?.id) {
    return <MentionTextarea label="Notes" value={value} onChange={onChange} users={users} rows={2} testid={testid} placeholder="Add a first note… use @ to mention" />;
  }
  return (
    <div data-testid={`${testid}-panel`}>
      <p className="mb-1.5 text-xs font-semibold text-slate-600">Notes</p>
      <div className="rounded-lg border border-slate-200 p-3">
        <NotesPanel entityType={entityType} entityId={record.id} legacyNote={record.notes} migratePath={`/${collection}/${record.id}/migrate-note`} />
      </div>
    </div>
  );
}
